import React, { useState, useEffect, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { ChequeCultureLegacy } from "./legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../service/ChequeCultureService";
import { LinkProviderService } from "../service/LinkProviderService";
import { FileService } from "../service/FileService";
import { ExerciceService } from "../service/ExerciceService";
import { useParams } from "react-router-dom";
import { FieldBuilder } from "./forms/fields/FieldBuilder";
import { RadioButton } from 'primereact/radiobutton';

export const ChequeCulture = () => {
  const { mode } = useParams();
  const [usager, setUsager] = useState(false);
  const [adresse, setAdresse] = useState(false);
  const [commande, setCommande] = useState(true);
  const [editCommande, setEditCommande] = useState(true);
  const [policyOne, setPolicyOne] = useState(false);
  const [policyTwo, setPolicyTwo] = useState(false);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const [showDemandeError, setShowDemandeError] = useState(false);
  const [maCommande, setMaCommande] = useState(true);
  const [justificatifPresence, setJustificatifPresence] = useState(null);
  const [hideJustificatif, setHideJustficatif] = useState(false);
  const [dematType, setDematType] = useState(false);
  const fileUploadRef = useRef(null);
  const toast = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const categoriesChoixDemat = [
          {  "value": false ,"description":"Papier"},
          {  "value": true ,"description":"Dématérialisé"}
      ];

  let fraisEnvoi;

  let createMode = "create";
  let editMode = "edit";
  let mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

  const text =<div><p>Politique de protection des données à caractère personnel</p>
          <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
          <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
          <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
          <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
          <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
          <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>


  const basicDialogFooter = (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
    <Button
      type="button"
      label="RETOUR ESPACE AGENT"
      onClick={(e) => logoutRemoveData(e)}
      className="btn_submit_modal"
    />
    <Button
      type="button"
      label="MES SUIVIS"
      onClick={(e) => logoutRemoveData(e)}
      className="btn_submit_modal"
    />
    </div>
  );

  const chequeCultureService = new ChequeCultureService();
  const fileService = new FileService();
  const linkService = new LinkProviderService();
  const exerciceService = new ExerciceService();
  useEffect(() => {

    fetchData();
  }, []);


  const fetchData = async () => {
    chequeCultureService.getUsagerInfo().then(
      (res) => {
        loadFormData(res.data);
      },
      [usager]
   );
    exerciceService.getExerciceEnCours();
  };




  const loadFormData = (loggedUsager) => {
    setUsager(loggedUsager);
    setAdresse(loggedUsager.adresse);
    if (loggedUsager != null && loggedUsager != undefined) {
      getParamDeleg(loggedUsager.codeDelegation);
      getJustificatifRequis();
    }
  };

  const justificatifsCategories = [
    { "key": "106", "value": "Justificatif de présence en établissement" ,"description":"Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%."}
  ];

  const editJustificatifMsg = 'Votre justificatif n’était pas conforme: joindre une copie de votre dernier bulletin de paie ou à défaut une attestation de travail délivrée par votre établissement.'

  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "ERREUR",
      detail:
        "Le justificatif à joindre est manquant. Merci d’en télécharger un",
      life: 5000,
    });
  };

  const showErrorMimeType = () => {
    toast.current.show({
      severity: "error",
      summary: "ERREUR",
      detail:
        "Le justificatif sélectionné ne correspond pas à l’un des formats de fichier acceptés. Merci d’en sélectionner un compatible.",
      life: 5000,
    });
  };

  const showInfo = (msg) => {
    toast.current.show({
      severity: "info",
      summary: "Succés",
      detail: msg + " envoyée avec succés. ",
      life: 5000,
    });
  };

  const getParamDeleg = async (codeDelegation) => {
    chequeCultureService
      .getParamChequeCulture(codeDelegation)
      .then((res) => {

      fraisEnvoi = res.data[0].fraisAffranchissement;

        if (mode == editMode) {
          loadCommandeForm();
        }
        const getProp = (prop) => (obj) => obj[prop];
        const getMontant = getProp("montant");
        const montans = res.data.map(getMontant);
        console.log("montants::" + montans);
        setMaCommande(
          res.data.map((param) => (
            <div className="alert alert-success" key={param.montant}>
              <input
                type="radio"
                value={param.montant}
                name="PMC_ID_RADIO"
                onChange={onCommandeChanged}
              />
              <b>
                &nbsp;&nbsp;&nbsp; Commander un chéquier d'une valeur de{" "}
                {param.montant}€{" "}
              </b>
              {res.data.length == 1 && (
                <i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 seule commande par
                  an.
                </i>
              )}
              {res.data.length == 2 && (
                <i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {Math.max(...montans) == param.montant
                    ? "1 seule commande par an."
                    : "2 commandes possibles par an. Attention, la deuxième commande peut ne pas être honorée si le budget disponible est atteint."}
                </i>
              )}
            </div>
          ))
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadCommandeForm = () => {
    chequeCultureService
      .getEditDto()
      .then((res) => {
        setEditCommande(res.data);
        let object = {
          valeurCommande: (res.data.montantTotal - fraisEnvoi) * 2,
          partCgos: res.data.montantTotal - fraisEnvoi,
          frais: fraisEnvoi,
          total: res.data.montantTotal,
        };
        setCommande(object);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getJustificatifRequis = async () => {
    chequeCultureService
      .getJustificatifRequis()
      .then((res) => {
        setHideJustficatif(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onCommandeChanged = (e) => {
    let choosedCommand = e.currentTarget.value;
    console.log(dematType);
    if(dematType){
        setCommande({
              valeurCommande: choosedCommand,
              partCgos: choosedCommand / 2,
              frais: 0,
              total: choosedCommand / 2,
              envoi: true,
            });
    }else{
        setCommande({
                      valeurCommande: choosedCommand,
                      partCgos: choosedCommand / 2,
                      frais: fraisEnvoi,
                      total: choosedCommand / 2+fraisEnvoi,
                      envoi: true,
                    });
    }

  };


  const handleAnnuler = () => {
    chequeCultureService.redirectEaLegacy();
  };

  const onPolicyOneChange = () => {
    setPolicyOne(!policyOne);
  };

  const onPolicyTwoChange = () => {
    setPolicyTwo(!policyTwo);
  };

  const logoutRemoveData = (e) => {
    chequeCultureService.logOut().then((res) => {
      console.log(res);
    });
    handleAnnuler();
  };

    const handleFilesError = (error) => {
              localStorage.setItem("errorMessage", error.response.data.message)
              window.location ="/#/serviceIndisponible/FH-" + error.response.data.errorId;
      }

  const submitEditedDemande = async (e) => {
    e.preventDefault();
    if(e.detail == 1){
        if (justificatifPresence && justificatifPresence.length > 0) {
              setDisabled(true);

                let recordIds=[];
                let categories=[];

                categories.push("106");
                recordIds.push(editCommande.recordId);
              fileService
                .uploadEditedFiles(justificatifPresence, recordIds,categories)
                .then((res) => {
                  if (null != res.data && res.data != undefined) {
                    showInfo("Justificatif");
                    updateEditedDemande(editCommande.demandeId);
                  } else {
                    setShowFileUploadError(true);
                  }
                })
                .catch((err) => {
                  handleFilesError(err);
                });
            } else {
              showError();
            }
        }
   }


  const submitFormDemande = async(e) => {
    e.preventDefault();
    if(e.detail == 1){
            const jsonFormSchema = { montant: commande.total, optionDemande: 0 };
            const CommandesArray = [];

            maCommande.forEach((com) => {
              CommandesArray.push(com.key);
            });

            if (commande.valeurCommande == Math.max(...CommandesArray)) {
              jsonFormSchema.optionDemande = 2;
            } else {
              jsonFormSchema.optionDemande = 1;
            }
            const demande = {
              etape: "1",
              origine: "NEA",
              exercice: localStorage.getItem('exerciceEnCours'),
              codeClasseur: "3710",
              demandeStatutReferentiel: { id: 1 },
              demandeDetails: [],
            };

            const demandeDetail = {
              demandeType: {
                codeActionSocial: "3710",
              },
              motif: dematType? "DEMAT":"PAPIER",
              formJson: JSON.stringify(jsonFormSchema),
              montant: commande.total,
              version: "1",
            };

            demande.demandeDetails.push(demandeDetail);

        if (hideJustificatif) {
          if (justificatifPresence && justificatifPresence.length > 0) {
            setDisabled(true);
            fileService
              .uploadMultiFile(justificatifPresence)
              .then((res) => {
                if (null != res.data && res.data != undefined) {
                  showInfo("Justificatif");
                  saveDemande(demande);
                } else {
                  setShowFileUploadError(true);
                }
              })
              .catch((err) => {
                handleFilesError(err);
              });
          } else {
            showError();
          }
        } else {
          setDisabled(true);
          saveDemande(demande);
        }
       }
  };

  const saveDemande = (demande) => {
    chequeCultureService
      .submitDemandeForm(demande)
      .then((res) => {
        setDisplayBasic(true);
        showInfo("Demande");
      })
      .catch((err) => {
        window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
      });
  };

  const updateEditedDemande = (demandeId) => {
    chequeCultureService
      .submitUpdatedDemande(demandeId)
      .then((res) => {
        setDisplayBasic(true);
        showInfo("Demande");
      })
      .catch((err) => {
        window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
      });
  };

  return (
    <div className="grid cld-width">
      <div className="col-12">
        <Toast ref={toast} position="top-center" className="toast-position" />
        <div
          className="no_shadow_no_border card "
          style={{ display: displayBasic ? "block" : "none" }}
        >
          <div className="border-round border-1 surface-border p-4">
            <Skeleton width="100%" height="400px"></Skeleton>
            <div className="flex justify-content-between mt-3">
              <Skeleton width="10rem" height="2rem"></Skeleton>
              <Skeleton width="10rem" height="2rem"></Skeleton>
            </div>
          </div>
        </div>

        <div
          className="no_shadow_no_border card "
          style={{ display: !displayBasic ? "block" : "none" }}
        >
          <ChequeCultureLegacy />

          <nav aria-label="breadcrumb" class="pt-3">
             <ol class="breadcrumb"><li class="breadcrumb-item">
             <a href={linkService.getRetourEaAccueilAgent()} target="_self">Espace Agent</a></li>
             <li class="breadcrumb-item">
            <a href={linkService.getRetourEaMembrePrestation()} target="_self">Prestations et Formulaires</a></li>
            <li aria-current="page" class="breadcrumb-item active">Demande d'une prestation</li>
           </ol>
          </nav>

          <h1 className="page-header" style={{ color: "#676767" }}>
            PRESTATIONS &gt; TITRES CULTURE
          </h1>

          <form
            action=""
            id="espaceAgent"
            method="POST"
            name="formCheque"
            className="form-horizontal cld-form-padding"
          >
            <Accordion multiple activeIndex={[1]}>
              <AccordionTab header="Comprendre la prestation">
                <div class="alert alert-info">
                  <p>
                    <em>
                      Le Titre Culture® vous permet d'accéder à tout l'univers
                      de la culture (livres, CD, DVD, BlueRay©, jeux vidéos...),
                      mais aussi de réserver des spectacles et sorties
                      culturels (théâtres, concerts, cinémas, expositions,
                      châteaux, monuments historiques, zoos, musées...).
                    </em>
                  </p>
                  <br />

                  <b>
                    <font size="3" color="#34495E">
                      Demander la prestation Titre Culture{" "}
                    </font>
                  </b>
                  <ul style={{ listStyleType: "circle" }}>
                    <li>
                      Vous payez le montant de votre participation uniquement :
                      <br />
                      &nbsp;&nbsp;par carte bancaire si vous commandez en ligne,
                      <br />
                      &nbsp;&nbsp;par chèque bancaire si vous commandez par
                      courrier.
                    </li>
                    <li>
                      Vous passez au choix une ou deux commandes par an (selon
                      les règles définies par le C.G.O.S de votre région).
                    </li>
                    <li>
                      Cette action, ouverte à tous, est versée dans la limite
                      des budgets disponibles. Elle n'est ni imposable ni
                      assujettie aux cotisations sociales.
                    </li>
                  </ul>
                  <br />
                  <b>
                    <font size="3" color="#34495E">
                      Délais de livraison
                    </font>
                  </b>
                  <ul style={{ listStyleType: "circle" }}>
                    <li>
                      Vous les recevrez directement à votre adresse postale
                      <sup>1</sup>, 4 à 6 semaines<sup>2</sup> après le paiement
                      de votre participation au C.G.O.S.{" "}
                    </li>
                    (1)&nbsp;&nbsp;Les Titres culture à destination de Mayotte
                    seront envoyés à votre établissement. Dès réception, ce
                    dernier vous proposera de les récupérer auprès du contact
                    C.G.O.S de référence.
                    <br />
                    (2)&nbsp;&nbsp;Le délai de livraison de la métropole vers
                    les départements et régions d'outre-mer peut prendre jusqu'à 2 à 3 semaines supplémentaires.
                  </ul>
                  <br />
                  <b>
                    <font size="3" color="#34495E">
                      Format et durée d'utilisation
                    </font>
                  </b>
                  <ul style={{ listStyleType: "circle" }}>
                    <li>
                      Un chéquier est composé de Titres Culture de 10 euros.
                      Ces chèques sont valables l'année en cours plus 2 ans.
                    </li>
                  </ul>
                  <br />
                  <b>
                    <font size="3" color="#34495E">
                      Utilisation des Titres Culture
                    </font>
                  </b>
                  <ul style={{ listStyleType: "circle" }}>
                    <li style={{ textAlign: "left" }}>
                      Consultez la liste des partenaires culturels qui acceptent
                      les Titres Culture sur le site
                    </li>
                  </ul>
                  <p style={{ textAlign: "center" }}>
                    <strong>
                      <a
                        style={{ color: "#1e1c1c" }}
                        href="http://cheques-cadeaux-culturels.fr"
                        target="_blank"
                      >
                        www.cheques-cadeaux-culturels.fr
                      </a>
                    </strong>
                    <br />
                    <br />
                  </p>
                  <ul style={{ listStyleType: "circle" }}>
                    <li>
                      Appelez la plateforme téléphonique, du lundi au samedi de
                      9h00 à 18h00 (horaires métropole) : 08 92 68 08 98.
                      <br /> Service 0,40 euro /appel + prix de l'appel.
                    </li>
                  </ul>
                  <br />
                  <b>
                    <font size="3" color="#34495E">
                      Echange des Titres Culture périmés
                    </font>
                  </b>
                  <ul style={{ listStyleType: "circle" }}>
                    <li>
                      {" "}
                      Vous devez les envoyer, avant le 31 mars de l'année qui
                      suit la date de fin de validité à : "UP", accompagnés du
                      bordereau d'échange.
                    </li>
                    <li>
                      {" "}
                      Le bordereau d'échange est téléchargeable sur{" "}
                      <a href="http://cgos.info" target="_blank">
                        {" "}
                        www.cgos.info{" "}
                      </a>{" "}
                      chaque année de janvier à février.
                    </li>
                    <li> Le montant à échanger doit être supérieur à 20€.</li>
                    <li> Une déduction des frais d'envoi du retour sera effectuée sur le montant des titres reproduits selon votre choix. En cas d'absence de choix, l'envoi simple sera appliqué.</li>
                    <li> Toute demande d'échange arrivée en dehors de la période d'échange, incomplète ou sans bordereau ne sera pas prise en compte. Les titres ne seront plus échangeables et définitivement perdus.</li>
                  </ul>
                </div>
              </AccordionTab>
              <AccordionTab header="Envoyer une demande (paiement uniquement par carte bancaire)">
                <div className="alert alert-info">
                  <p>
                    <b>
                      Si vos données personnelles ou votre adresse ne sont pas
                      correctes, vous pouvez demander une mise à jour depuis la
                      rubrique{" "}
                      <a href={linkService.getRetourEaMembreFiche()}>
                        {" "}
                        Mes infos puis Données personnelles.
                      </a>
                    </b>
                  </p>
                </div>

                <h2 className="cld-h2">Mes données personnelles</h2>
                <dl className="dl-horizontal">
                  <dt>Numéro C.G.O.S</dt>
                  <dd>{usager.numCgos}</dd>
                  <dt>Nom établissement</dt>
                  <dd>{usager.libelleEtablissement}</dd>
                  <dt>Nom</dt>
                  <dd>{usager.nom}</dd>
                  <dt>Prénom</dt>
                  <dd>{usager.prenom}</dd>
                  <dt>EMAIL PERSONNEL</dt>
                  <dd>{usager.email}</dd>
                </dl>

                <h2 className="cld-h2">Mon adresse personnelle</h2>

                <dl className="dl-horizontal">
                  <dt>Appart., escalier</dt>
                  <dd>{adresse.adresse1}</dd>
                  <dt>Bâtiment, entrée, résidence</dt>
                  <dd>{adresse.adresse2}</dd>
                  <dt>N° et voie</dt>
                  <dd>{adresse.adresse3}</dd>

                  <dt>Pays</dt>
                  <dd>{adresse.pays}</dd>
                  <dt>Code postal</dt>
                  <dd>{adresse.codePostal}</dd>
                  <dt>Ville</dt>
                  <dd>{adresse.ville}</dd>
                  <dt>Lieu-dit</dt>
                  <dd>{adresse.adresse4}</dd>
                </dl>


                <h2 className="cld-h2">Choix type Titre Culture</h2>
                   <br />
                 <div className="fileupload-radio col-12">
                                                   {
                                                       categoriesChoixDemat && categoriesChoixDemat.map((category, index) => {
                                                           return (
                                                           <div>
                                                               <div key={index} className="field-radiobutton">
                                                                   <RadioButton inputId={index} name="category" value={category} onChange={(e) => setDematType(e.value.value)} checked={dematType === category.value} />
                                                                   <label className="form-block-info" htmlFor={index}><b>{category.description}</b></label>
                                                               </div>
                                                           </div>
                                                           )
                                                       })
                                                   }
                 </div>


                <br />
                {mode == createMode && <h2 className="cld-h2">Ma Commande</h2>}

                {mode == createMode && maCommande}

                <input
                  type="hidden"
                  name="$DTO_RECHERCHE_AGENT$PMC_ID"
                  id="PMC_ID"
                  value=""
                />

                {mode == createMode && (
                  <div className="alert alert-info">
                    Cette prestation, ouverte à tous, est versée dans la limite
                    des budgets disponibles. Des frais d'envoi peuvent vous être
                    demandés uniquement lorsqu'ils sont effectués en recommandé.
                    <p></p>
                  </div>
                )}

                <h2 className="cld-h2">Récapitulatif de la demande</h2>

                <div id="div2" style={{ display: "block" }}>
                  <dl className="dl-horizontal">
                    <dt>Valeur commandée</dt>
                    <dd>
                      {typeof commande.valeurCommande !== "undefined" &&
                        commande.valeurCommande.toLocaleString("fr-FR") + " €"}
                    </dd>
                    <dt>Participation C.G.O.S &nbsp; 50% </dt>
                    <dd>
                      {typeof commande.partCgos !== "undefined" &&
                        commande.partCgos.toLocaleString("fr-FR") + " €"}
                    </dd>
                    <dt>Frais d'envoi</dt>
                    <dd>
                      {typeof commande.frais !== "undefined" &&
                        commande.frais.toLocaleString("fr-FR") + " €"}
                    </dd>
                    <dt>TOTAL à payer</dt>
                    <dd>
                      {typeof commande.total !== "undefined" &&
                        commande.total.toLocaleString("fr-FR") + " €"}
                    </dd>
                  </dl>
                </div>

                <br />

                {hideJustificatif && (
                  <div name="jutificatif_area">
                    <h2 className="cld-h2">Justificatif à joindre</h2>
                    <div className="alert alert-info">
                      Joindre une copie de votre dernier bulletin de paie ou à
                      défaut une attestation de travail délivrée par votre
                      établissement.
                    </div>
                    <br />
                    <ul
                      style={{ listStyleType: "decimal" }}
                      data-mce-style="list-style-type: decimal;"
                    >
                      <li>
                        <label>
                          Je numérise le justificatif demandé
                          <i
                            className="pi pi-question-circle"
                            style={{ margin: "3pt" }}
                          ></i>{" "}
                          <a
                            target="_blank"
                            href="https://www.youtube.com/watch?v=-_kRF_ifTc4"
                          >
                            {" "}
                            Comment numériser
                          </a>
                        </label>
                      </li>
                      <li>
                        <label>Je le transmets ci-dessous</label>
                      </li>
                    </ul>
                    <br />
                    <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategories, 10000000, false, mode === editMode ? editJustificatifMsg : null]} onValueChange={(e) => setJustificatifPresence(e)} />
                    <br />
                  </div>
                )}

                <h2 className="cld-h2">Validation de la demande</h2>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      id="check1"
                      onChange={onPolicyOneChange}
                    />{" "}
                    Je déclare sur l'honneur l'exactitude des informations
                    concernant ma situation professionnelle, familiale et
                    financière et je déclare être informé que quiconque se rend
                    coupable de fraude, production de documents falsifiés comme
                    justificatifs, fausses déclarations est passible des peines
                    d'amendes et/ou d'emprisonnement.
                  </label>
                </div>

                <div>
                  <label>
                    <input
                      type="checkbox"
                      id="check2"
                      onChange={onPolicyTwoChange}
                    />{" "}
                    En cochant cette case, je déclare avoir pris connaissance et
                    accepter sans réserve la politique protection des données
                    applicable aux informations renseignées dans ce formulaire.
                  </label>
                </div>
                <br />


                <div id="textarea" >
                  <span>{text}</span>
                   <br></br>
                   <p>
                   Pour en savoir plus, consultez la <a href='https://www.cgos.info/17/politique-protection-donnees' target='_blank'>page d'information sur la politique de protection des données du C.G.O.S.</a>
                   </p>
                </div>


                <br />
                <div className="alert alert-info">
                  Dès que le C.G.O.S aura validé votre demande, vous recevrez un
                  Email vous invitant à régler votre participation par Carte
                  bancaire directement depuis votre Espace agent. Ce réglement
                  doit avoir lieu <strong>dans les 48 H </strong>
                  suivant la réception de cet Email, faute de quoi votre demande
                  sera annulée.
                  <p></p>
                </div>
                <br />

                <div className="form-group">
                  <div className="navButtons cld-submit-buttons">
                    <button
                      className="btn invalide"
                      type="button"
                      style={{ backgroundColor: "#C9C9C9" }}
                      name="RETOUR_PRESTATION"
                      onClick={logoutRemoveData}
                    >
                      ANNULER
                    </button>

                    {mode == createMode && (
                      <button
                        className="btn"
                        type="button"
                        onClick={submitFormDemande}
                        name="ENVOYER_MA_DEMANDE"
                        disabled={
                          disabled ||
                          !commande.envoi ||
                          !policyOne ||
                          !policyTwo ||
                          !usager.numCgos
                        }
                      >
                        Envoyer ma demande
                      </button>
                    )}

                    {mode == editMode && (
                      <button
                        disabled={
                          disabled ||
                          !policyOne ||
                          !policyTwo ||
                          !usager.numCgos
                        }
                        className="btn"
                        type="button"
                        name="ENVOYER_MA_DEMANDE"
                        onClick={submitEditedDemande}
                      >
                        Envoyer ma demande
                      </button>
                    )}

                    <br />
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
            <Dialog
              closable={false}
              header=""
              visible={displayBasic}
              modal
              footer={basicDialogFooter}
            >
              <center>
                <h2>
                  Votre demande a bien été envoyée et sera étudiée dans les
                  meilleurs délais. <br />{" "}
                </h2>
                <br />
                <h4>
                  Consultez le contrat, le mandat et l'avancement de cette demande{" "}
                  <a href={linkService.getRetourEaMembreSuiviDemande()}>
                    rubrique Mes suivis.
                  </a>
                </h4>
                <br />
              </center>
            </Dialog>

            <Dialog closable={false} header="" visible={showDemandeError} modal>
              <center>
                <h2>
                  Un problème est survenu lors de l'envoi de votre demande de
                  prestation : <b>{codeError}</b>
                  <br />
                </h2>
                <br />
                <h3>
                  Pour renvoyer votre demande allez sur le formulaire de demande{" "}
                </h3>
                <br />
                <br />
                <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
                <br />
                <Button
                  type="button"
                  label="RÉAFFICHER LE FORMULAIRE"
                  onClick={() => window.location.reload(false)}
                  className="btn_submit_modal"
                />
              </center>
            </Dialog>

            <Dialog
              closable={false}
              header=""
              visible={showFileUploadError}
              modal
            >
              <center>
                <h2>
                  Echec d'envoi de votre demande de prestation Chèques culture{" "}
                  <br />
                </h2>
                <br />
                <h3>
                  En raison d’un problème technique : <b>{codeError}</b> les
                  documents joints à votre demandes n’ont pas pu être
                  enregistrés.
                </h3>
                <br />
                <h3>
                  Merci de nous renvoyer votre demande après vous être assuré
                  que les documents joints à celle-ci sont conformes aux
                  caractéristiques (taille, format) indiquées sur le formulaire.
                </h3>
                <br />
                <Button
                  type="button"
                  label="RÉAFFICHER LE FORMULAIRE"
                  onClick={() => window.location.reload(false)}
                  className="btn_submit_modal"
                />
              </center>
            </Dialog>


          </form>
        </div>
      </div>
    </div>
  );
};
